import { render, staticRenderFns } from "./consultation-sections.html?vue&type=template&id=b2b6b6b2&scoped=true&external"
import script from "./consultation-sections.js?vue&type=script&lang=js&external"
export * from "./consultation-sections.js?vue&type=script&lang=js&external"
import style0 from "./consultation-sections.scss?vue&type=style&index=0&id=b2b6b6b2&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2b6b6b2",
  null
  
)

export default component.exports